document.addEventListener("DOMContentLoaded", function () {
  const scroll_content = document.querySelector(".scroll_content");

  if (scroll_content) {
    new Swiper(".scroll_content", {
      slidesPerView: 1,
      spaceBetween: 15,
      breakpoints: {
        320: {
          slidesPerView: 1.5,
        },
        750: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3.5,
        },
        1320: {
          slidesPerView: 4.5,
        },
      },
    });
  }

  document
    .querySelectorAll(".footer-block.grid__item:not(:first-child) h2")
    .forEach((item) => {
      item.addEventListener("click", function () {
        const next = item.nextElementSibling;
        if (next) {
          item.classList.toggle("active");
          next.classList.toggle("active");
        }
      });
    });

  window.addEventListener("resize", () => {
    if (window.location.pathname.indexOf("/products") != -1) {
      const el = document.querySelector(".product__media-wrapper");
      if (
        /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        window.innerWidth <= 749
      ) {
        const reference = document.querySelector(
          ".product-form__input.product-form__quantity"
        );
        reference.before(el);
      } else {
        const reference = document.querySelector(".product__info-wrapper");
        reference.after(el);
      }
    }
  });

  document.querySelectorAll(".accordion__item").forEach((item) => {
    const header = item.querySelector(".accordion__header");
    const content = item.querySelector(".accordion__content");

    if (header && content) {
      header.addEventListener("click", function () {
        const isOpen = item.classList.contains("is-accordion-open");

        if (isOpen) {
          // CLOSE
          content.style.maxHeight = 0;
          item.classList.remove("is-accordion-open");
        } else {
          // OPEN
          document.querySelectorAll(".accordion__item").forEach((otherItem) => {
            if (otherItem !== item) {
              const otherContent = otherItem.querySelector(
                ".accordion__content"
              );
              if (otherContent) {
                otherContent.style.maxHeight = 0;
                otherItem.classList.remove("is-accordion-open");
              }
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
              item.classList.add("is-accordion-open");
            }
          });
        }
      });
    }
  });

  document.querySelectorAll(".product-schema-1__item").forEach((item) => {
    item.addEventListener("click", function () {
      const isOpen = item.classList.contains("item--open");

      if (!isOpen) {
        // OPEN
        document
          .querySelectorAll(".product-schema-1__item")
          .forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.classList.remove("item--open");
            } else {
              item.classList.add("item--open");
            }
          });
      }
    });
  });
});

if (window.location.pathname.indexOf("/products") != -1) {
  const observer = new MutationObserver(() => {
    const el = document.querySelector(".product__media-wrapper");

    if (el) {
      observer.disconnect();

      if (
        /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        window.innerWidth <= 749
      ) {
        const reference = document.querySelector(
          ".product-form__input.product-form__quantity"
        );
        reference.before(el);
      } else {
        const reference = document.querySelector(".product__info-wrapper");
        reference.after(el);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const observe = new MutationObserver(() => {
    const el = document.querySelector(
      '[data-class="product_buy_button_block"]'
    );

    if (el) {
      const reference = document.querySelector(
        ".product-form__input.product-form__quantity"
      );
      if (
        /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        window.innerWidth <= 749
      ) {
        if (reference && reference.parentNode) {
          reference.parentNode.insertBefore(el, reference.nextSibling);
        }
      } else {
        if (reference) {
          reference.appendChild(el);
        }
      }
      observe.disconnect();
    }
  });
  observe.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("resize", function () {
    const el = document.querySelector(
      '[data-class="product_buy_button_block"]'
    );

    if (el) {
      const reference = document.querySelector(
        ".product-form__input.product-form__quantity"
      );
      if (
        /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        window.innerWidth <= 749
      ) {
        if (reference && reference.parentNode) {
          reference.parentNode.insertBefore(el, reference.nextSibling);
        }
      } else {
        if (reference) {
          reference.appendChild(el);
        }
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tabs__button");
  const tabItems = document.querySelectorAll(".tabs__item");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const targetTab = this.getAttribute("data-tab");

      tabs.forEach((t) => t.classList.remove("is-active"));
      tabItems.forEach((item) => item.classList.remove("is-active"));

      this.classList.add("is-active");
      document
        .querySelector(`.tabs__item[data-tab="${targetTab}"]`)
        .classList.add("is-active");
    });
  });
});

document.querySelectorAll(".video-grid__item").forEach((item) => {
  const playBtn = item.querySelector("[data-play-button]");
  const videoContainer = item.querySelector("[data-video-container]");
  const thumbnail = item.querySelector("[data-video-thumbnail]");

  if (!playBtn || !videoContainer || !thumbnail) return;

  playBtn.addEventListener("click", function () {
    thumbnail.style.display = "none";
    videoContainer.style.display = "block";
    const video = videoContainer.querySelector("video");
    video.play();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sliderElements = document.querySelectorAll(".mobile-slider");
  sliderElements.forEach((sliderElement) => {
    new Swiper(sliderElement, {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
});

let currentSwipers = [];
let currentScrollTriggers = [];

function initMobileSlider() {
  currentSwipers.forEach((swiper) => swiper.destroy(true, true));
  currentSwipers = [];

  currentScrollTriggers.forEach((trigger) => trigger.kill());
  currentScrollTriggers = [];

  if (typeof Swiper === "undefined") return;

  document.querySelectorAll(".scroll-section__mobile").forEach((wrapper) => {
    const scrollSection = wrapper.querySelector(".scroll-slider");
    const scrollPagination = wrapper.querySelector(".swiper-pagination");

    if (!scrollSection || !scrollPagination) return;

    const swiper = new Swiper(scrollSection, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: scrollPagination,
        clickable: true,
      },
    });

    currentSwipers.push(swiper);
  });
}

function initDesktopScrollTrigger() {
  currentSwipers.forEach((swiper) => swiper.destroy(true, true));
  currentSwipers = [];

  currentScrollTriggers.forEach((trigger) => trigger.kill());
  currentScrollTriggers = [];

  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn("GSAP or ScrollTrigger not loaded");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll("[data-scroll-id]").forEach((wrapper) => {
    const items = wrapper.querySelectorAll(".scroll-text");
    const images = wrapper.querySelectorAll(".scroll-image");
    const scrollTrigger = wrapper;

    if (!scrollTrigger || items.length === 0 || images.length === 0) {
      console.warn("Scroll elements not found");
      return;
    }

    gsap.set([items, images], { clearProps: "all" });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scrollTrigger,
        start: "top top",
        end: "+=200%",
        pin: scrollTrigger,
        pinSpacing: true,
        scrub: 1,
        markers: false,
        refreshPriority: 1,
      },
    });

    currentScrollTriggers.push(tl.scrollTrigger);

    gsap.set(items, { opacity: 1, y: 0 });
    gsap.set(images, { opacity: 0, y: 200 });

    if (images[0]) gsap.set(images[0], { opacity: 1, y: 0 });

    items.forEach((item, index) => {
      if (index === 0) {
        item.style.height = "auto";
        item.style.overflow = "visible";
      } else {
        item.style.height = "30px";
        item.style.overflow = "hidden";
      }

      if (index > 0) {
        const prevItem = items[index - 1];
        const prevImage = images[index - 1];
        const currImage = images[index];

        tl.to(
          prevItem,
          {
            y: 0,
            height: "30px",
            duration: 0.3,
            ease: "power2.inOut",
            onStart: () => {
              prevItem.style.overflow = "hidden";
            },
          },
          `item${index}`
        )

          .to(
            prevImage,
            {
              opacity: 0,
              y: -100,
              duration: 0.3,
              ease: "power2.inOut",
            },
            `item${index}`
          )

          .to(
            item,
            {
              opacity: 1,
              y: 0,
              height: "auto",
              duration: 0.2,
              ease: "power2.out",
              onStart: () => {
                item.style.overflow = "hidden";
                item.style.height = "auto";
                const autoHeight = item.offsetHeight;
                gsap.to(item, {
                  height: autoHeight,
                  duration: 0.2,
                  ease: "power2.out",
                });
              },
            },
            `item${index}+=0.3`
          )

          .to(
            currImage,
            {
              opacity: 1,
              y: 0,
              duration: 0.2,
              ease: "power2.out",
            },
            `item${index}+=0.3`
          );
      }
    });
  });
}

function initializeBasedOnScreenSize() {
  if (window.innerWidth < 750) {
    initMobileSlider();
  } else {
    initDesktopScrollTrigger();
  }
}

// DOM ready
document.addEventListener("DOMContentLoaded", () => {
  initializeBasedOnScreenSize();
});

// Resize handling with debounce
let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
    initializeBasedOnScreenSize();
  }, 250);
});

// Orientation change on mobile
window.addEventListener("orientationchange", () => {
  setTimeout(() => {
    initializeBasedOnScreenSize();
  }, 500);
});

if (window.location.pathname.indexOf("/pages/blogs") != -1) {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".blog-tags p").forEach((tag) => {
      tag.addEventListener("click", function () {
        const tagName = this.getAttribute("data-tag");

        document.querySelectorAll(".blog-tags p").forEach((otherTag) => {
          if (otherTag !== this) {
            otherTag.classList.remove("active");
          }
        });

        this.classList.toggle("active");

        tag
          .closest(".blog-all-articles")
          .querySelectorAll(".blog-articles__item")
          .forEach((article) => {
            if (article) {
              if (this.classList.contains("active")) {
                const articleTagsAttr = article.getAttribute("data-tags");
                if (articleTagsAttr) {
                  const articleTags = articleTagsAttr
                    .split(",")
                    .map((t) => t.trim());
                  if (articleTags.includes(tagName)) {
                    article.style.display = "block";
                  } else {
                    article.style.display = "none";
                  }
                }
              } else {
                // Show all articles when no tag is active
                article.style.display = "block";
              }
            }
          });
      });
    });
  });
}

if (window.location.pathname.includes("/products/")) {
  document.addEventListener("DOMContentLoaded", () => {
    const SELECTORS = {
      title: ".product__title h1",
      image: ".product__media.media img",
      coverage: ".product--coverage",
      addToCart: ".product-form__submit",
      price: ".price__container",
      sticky: ".sticky_product",
      trigger: "product-info",
      main: "main#MainContent",
    };

    function createStickyProduct() {
      if (document.querySelector(SELECTORS.sticky)) return;

      const titleEl = document.querySelector(SELECTORS.title);
      const imageEl = document.querySelector(SELECTORS.image);
      const coverageEl = document.querySelector(SELECTORS.coverage);
      const addToCartBtn = document.querySelector(SELECTORS.addToCart);
      const priceEl = document.querySelector(SELECTORS.price);

      if (!titleEl || !imageEl || !addToCartBtn) return;

      const sticky = document.createElement("div");
      sticky.className = "sticky_product active";

      sticky.innerHTML = `
        <div class="page-width">
          <div class="sticky_product__wrapper">
            <div class="sticky_product__left">
              <div class="sticky_product__image">
                <img src="${imageEl.src}" alt="${titleEl.textContent.trim()}">
              </div>
              <div class="sticky_product__info">
                <p class="ff-desktop-10">${titleEl.textContent.trim()}</p>
                <p class="ff-desktop-12">${
                  coverageEl?.textContent.trim() || ""
                }</p>
              </div>
            </div>
            <div class="sticky_product__right">
              ${priceEl ? priceEl.cloneNode(true).outerHTML : ""}
              <button class="button button--primary sticky_cart" ${
                addToCartBtn.disabled ? "disabled" : ""
              }>
                <span>Add to Cart</span>
                <div class="loading__spinner hidden">
                  <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                </div>
              </button>
            </div>
          </div>
        </div>`;

      const button = sticky.querySelector(".sticky_cart");
      button.addEventListener("click", (e) => {
        e.preventDefault();
        if (!addToCartBtn.disabled) {
          button.classList.add("loading");
          button.querySelector(".loading__spinner").classList.remove("hidden");
          addToCartBtn.click();
          setTimeout(() => {
            button.classList.remove("loading");
            button.querySelector(".loading__spinner").classList.add("hidden");
          }, 1000);
        }
      });

      document.querySelector(SELECTORS.main)?.prepend(sticky);
    }

    function removeStickyProduct() {
      document.querySelector(SELECTORS.sticky)?.remove();
    }

    window.addEventListener("scroll", () => {
      const triggerEl = document.querySelector(SELECTORS.trigger);
      if (!triggerEl) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const triggerHeight = triggerEl.offsetHeight + 100;

      if (scrollTop > triggerHeight) {
        createStickyProduct();
      } else {
        removeStickyProduct();
      }
    });
  });
}

if (window.location.pathname.indexOf("/pages/discount-programs") != -1) {
  const observer = new MutationObserver(() => {
    const discountForm = document.querySelector("form.g-container");
    if (discountForm) {
      observer.disconnect();
      discountForm.querySelector(".wizard__content > p").remove();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".text-block-items__item");

  // Create intersection observer for counter animation
  const counterObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const item = entry.target;
          // Only start animation if it hasn't been started yet
          if (!item.dataset.animated) {
            item.dataset.animated = "true";
            Count(item);
          }
        }
      });
    },
    {
      threshold: 0.5, // Trigger when 50% of the element is visible
      rootMargin: "0px 0px -50px 0px", // Trigger slightly before fully visible
    }
  );

  items.forEach((item) => {
    if (item) {
      // Initialize display to 0
      const span = item.querySelector("span");
      if (span) {
        span.textContent = "0";
      }
      // Observe the item for intersection
      counterObserver.observe(item);
    }
  });
});

function Count(item1) {
  const count = parseFloat(item1.dataset.target ?? "0");
  const period = parseFloat(item1.dataset.period ?? "1"); // seconds
  const step = parseFloat(item1.dataset.step ?? "0.1");

  const span = item1.querySelector("span");
  if (
    !span ||
    Number.isNaN(count) ||
    Number.isNaN(period) ||
    Number.isNaN(step)
  )
    return;

  let current = 0;

  const increment = () => {
    if (current >= count) {
      if (step < 1) {
        span.textContent = count.toFixed(1);
      } else {
        span.textContent = count.toFixed(0);
      }
      return;
    }

    // Add step and clamp/round to 1 decimal
    const next = Math.min(count, Math.round((current + step) * 10) / 10);
    current = next;

    if (step < 1) {
      span.textContent = current.toFixed(1);
    } else {
      span.textContent = current.toFixed(0);
    }

    if (current < count) {
      setTimeout(increment, period * 1000);
    }
  };

  // Start the animation
  increment();
}

// document.addEventListener("DOMContentLoaded", function () {
//   const menuItems = document.querySelectorAll("a.mega_menu__item");

//   menuItems.forEach(btn => {
//     btn.addEventListener("mouseenter", () => {
//       const dataindex = btn.getAttribute("data-index");
//       if(!dataindex) return;

//       // Remove active class from all sublinks first
//       const allSublinks = btn.closest('.mega_menu__inner').querySelectorAll('.mega_menu__sublinks-inner');
//       allSublinks.forEach(sublink => sublink.classList.remove("active"));

//       // Add active class to current sublink
//       const sublink = btn.closest('.mega_menu__inner').querySelector(`.mega_menu__sublinks-inner[data-index="${dataindex}"]`);
//       if(sublink) {
//         sublink.classList.add("active");
//       }
//     });
//   });

//   // Optional: Add mouseleave handler for the menu container to reset state
//   const menuContainer = document.querySelector('.mega_menu__inner');
//   if(menuContainer) {
//     menuContainer.addEventListener("mouseleave", () => {
//       const allSublinks = menuContainer.querySelectorAll('.mega_menu__sublinks-inner');
//       allSublinks.forEach(sublink => sublink.classList.remove("active"));
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(
    "li.drawer__menu-item-main.mega_menu>span"
  );

  links.forEach((link) => {
    link.addEventListener("click", () => {
      const accountIcon = document.querySelector("a.custom.account-icon");
      if (accountIcon) {
        accountIcon.innerHTML =
          '{{ "icon-account.svg" | inline_asset_content }}';
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const drawerLinks = document.querySelectorAll(
    "li.drawer__menu-item-main.mega_menu > span"
  );

  drawerLinks.forEach((link) => {
    if (!link) return;

    link.addEventListener("click", function (e) {
      const next = link.nextElementSibling;
      if (next) {
        next.classList.toggle("active");
      }
    });
  });
});
